<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">
        <i :class="calcClass">{{$t("nav.portfolioCompanies")}}</i>
        <div class="img_desc">{{$t("homeAbout.portfolioCompaniesEn")}}
      </div>
    </div>
    </div>
    <!--公司介绍-->
    <div class="introduced">
      <div class="company" style="margin-bottom: 20px;">
        <div class="title">{{$t("homeAbout.company3")}}</div>
        <div class="website" @click="handleJump('http://www.shunxinchang.com')">http://www.shunxinchang.com</div>
      </div>
      <div class="profile">
        <div class="profile-right" v-animate-on-scroll="'animate__backInRight'">
          <div class="profile-left" v-animate-on-scroll="'animate__backInLeft'">
            <img style="border-radius: 10px;" src="@/assets/img/other/1746614478_Hz5V.jpg" alt="">
          </div>
          <span class="presentes">
            <span class="presentes-title">{{$t("companies.presentedTitle")}}</span>
            <span class="presentes-sub">{{$t("companies.presentedSubtitle")}}</span>
          </span>
          <span class="describe">
            {{$t("shunxing.describe1")}}
          </span>
          <span class="describe">
            {{$t("shunxing.describe2")}}
          </span>
        </div>
      </div>
    </div>
    <!--公司理念-->
    <div class="benchmarking">
      <div class="jiaosou">
        <div class="presented" style="text-align: center;">
          <div class="presented-title"> {{$t("shunxing.presentedTitle1")}}</div>
          <div class="presented-sub"> {{$t("shunxing.presentedSubtitle1")}}</div>
        </div>
        <div class="line2">
          <img src="@/assets/img/other/1746615085_EQXY.png" alt="">
          <div class="desc">
            <div style="color: #000; font-size: 1.2rem; font-weight: bolder; margin-bottom: 10px;"> {{$t("shunxing.presentedDescTitle")}}</div>
            <div>{{$t("shunxing.presentedDesc1")}}</div>
            <div>{{$t("shunxing.presentedDesc2")}}</div>
            <div>{{$t("shunxing.presentedDesc3")}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="jyfw">
      <div class="presented" style="text-align: center; margin-bottom: 20px;">
        <div class="presented-title">{{$t("shunxing.presentedTitle2")}}</div>
        <div class="presented-sub">{{$t("shunxing.presentedSubtitle2")}}</div>
      </div>
      <img src="@/assets/img/other/1746615260_y6rQ.png" alt="">
    </div>
    <div class="jyfw">
      <div class="presented" style="text-align: center;">
        <div class="presented-title">{{$t("shunxing.presentedTitle3")}}</div>
        <div class="presented-sub">{{$t("shunxing.presentedSubtitle3")}}</div>
      </div>
      <img src="@/assets/img/other/1746615672_0ei4.png" alt="">
    </div>
    <div class="dbssqy">
      <div class="presented" style="text-align: center;">
        <div class="presented-title">{{$t("companies.benchmarkingTitle")}}</div>
        <div class="presented-sub">{{$t("shunxing.benchmarkingSubtitle")}}</div>
      </div>
      <div class="presented" style="text-align: left;">
        <div class="presented-title">{{$t("shunxing.presentedTitle4")}}</div>
        <div class="presented-sub">{{$t("shunxing.presentedSubtitle4")}}</div>
      </div>
      <div class="imgs">
        <img src="@/assets/img/other/1746616089_VQLY.png" alt="">
        <img src="@/assets/img/other/1746616126_2xDP.png" alt="">
      </div>
    </div>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CallMe from '@/components/callme/index'
export default {
  computed:{
    calcClass()
    {
      return (this.$i18n.locale === 'en' || this.$i18n.locale === 'ar') ? 'english-layout' : '';
    }
  },
  data() {
    return {}
  },
  methods: {
    handleJump(src)
    {
      window.open(src, '_blank');
    }
  },
  components: {
    CallMe
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
  background-color: #fff;
  font-family: $font-family;
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/other/1749520018_lP3M.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .img_tit {
      width: 70%;
      font-weight: bold;
      margin: 0 auto;
      transition: all 0.5s ease 0s;

      i {
        font-size: $banner-font-size;
        border-bottom: 4px #fff solid;
        padding-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: $phone-banner-font-size;
        }
      }
    }

    .img_desc {
      font-size: $banner-sub-font-size;
      margin-top: 15px;
      text-transform: uppercase;
      @media screen and (max-width: 768px) {
        font-size: $phone-banner-sub-font-size;
      }
      outline: none;
    }
  }
  .company{
    text-align: center;
    padding: 40px 0 20px 0;
    @media screen and (max-width: 768px) {
      padding: 2rem 0 1rem 0
    }
    .title{
      font-size: $company-font-size;
      font-weight: bold;
      color: #000000;
      @media screen and (max-width: 768px) {
        font-size: $phone-company-font-size;
      }
    }
    .website{
      font-size: $web-font-size;
      color: #333333;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        font-size: $phone-web-font-size;
        padding: 0.3rem 0;
      }
    }
    .code{
      font-size: $code-font-size;
      color: #fccc0c;
      @media screen and (max-width: 768px) {
        font-size: $phone-code-font-size;
      }
    }
  }
  .header{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      padding:1.2rem 0;
    }
    .title{
      font-size:$title-font-size;
      color:#000000;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
      }
    }
    .sub{
      /*margin-top: 2px;*/
      font-size:$subtitle-font-size;
      color:#fccc0c;
      @media screen and (max-width: 768px) {
        margin-top: 0.2rem;
        font-size: $phone-subtitle-font-size;
      }
    }
  }
  //公司介绍
  .introduced{
    .company{
      text-align: center;
      padding: 40px 0 20px 0;
      @media screen and (max-width: 768px) {
        padding: 2rem 0 1rem 0
      }
      .title{
        font-size: $company-font-size;
        font-weight: bold;
        color: #000000;
        @media screen and (max-width: 768px) {
          font-size: $phone-company-font-size;
        }
      }
      .website{
        font-size: $web-font-size;
        color: #333333;
        cursor: pointer;
        padding: 0.3rem 0;
        @media screen and (max-width: 768px) {
          font-size: $phone-web-font-size;
        }
      }
      .code{
        font-size: $code-font-size;
        color: #fccc0c;
        @media screen and (max-width: 768px) {
          font-size: $phone-code-font-size;
        }
      }
    }
  }
  .profile{
    width: 70%;
    margin: 0 auto;
    position: relative;
    padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 90%;
    }
    .profile-left{
      float: left;
      overflow: hidden;
      position: relative;
      height: 35vh;
      width: 560px;
      margin-right: 20px;
      @media screen and (max-width: 768px) {
        height: 20rem;
        width: 100%;
        margin-right:0
      }
      img{
        height: 100%;
        width: 100%;
      }
    }
    .profile-right{
      margin-top: 25px;
      margin-left: 40px;
      flex: 1;
      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        margin: 0 0.3rem;
      }
      .presentes{
        display: flex;
        flex-direction: column;
        font-size: 1.8rem;
        font-weight: bold;
        color: #000000;
        @media screen and (max-width: 768px) {
          font-size: 1.3rem;
          align-items: center;
          padding: 1rem 0;
        }
        .presentes-sub{
          font-size: 1.2rem;
          color: #fccc0c;
          font-weight: normal;
          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
          }
        }
      }
      .describe{
        width: 550px;
        font-size: $content-font-size;
        color: #000000;
        line-height: 2;
        margin-top: 5px;
        @media screen and (max-width: 768px) {
          font-size: $phone-content-font-size;
          width: 100%;
        }
      }
      li{
        list-style-type: none;
      }
      .decision{
        font-size: 1.2rem;
        color: #000000;
        line-height: 2;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          margin-top: 0.4rem;
        }
      }
    }
    .jieshun{
      @media screen and (max-width: 768px) {
        position: relative;
      }
    }
    .textual{
      @media screen and (max-width: 768px) {
        position: absolute;
        top: 0;
        height: 20rem;
        width: 100%;
      }
    }
    .profile-company{
      position: relative;
      margin-left:0!important;
      margin-right:40px;
      @media screen and (max-width: 768px) {
        padding: 0 0.5rem ;
        margin-top: 20rem !important;
      }
    }
  }
  .profile:after{
    content: "";
    display: block;
    clear: both;
  }
  .presented-title{
    font-size: $title-font-size!important;
    @media screen and (max-width: 768px) {
      font-size: $phone-title-font-size!important;
    }
  }
  .presented-sub{
    font-size: $subtitle-font-size!important;
    padding-bottom: 30px;
    @media screen and (max-width: 768px) {
      font-size: $phone-subtitle-font-size!important;
    }
  }
  //产品优势
  .product-advantages{
    height: 500px;
    background-image: url("../../assets/img/home/1746602841_rvJN.jpg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    @media screen and (max-width: 768px) {
      height: 18rem;
    }
    .scene{
      .scene-list{
        margin: 0 15%;
        @media screen and (max-width: 768px) {
          margin: 0;
        }
        .scene-item{
          padding: 20px 40px;
          margin-bottom: 10px;
          @media screen and (max-width: 768px) {
            //padding: 1rem 2rem;
          }
          .item{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon{
              height: 48px;
              width: 48px;
              @media screen and (max-width: 768px) {
                height: 2.5rem;
                width: 2.5rem;
              }
            }
            .title{
              margin-top: 20px;
              font-size: 1px;
              font-weight: bold;
              margin-bottom: 26px;
              word-wrap: break-word;
              @media screen and (max-width: 768px) {
                font-size: 1rem;
                font-weight: normal;
                margin-bottom: 1rem;
              }
            }
          }
        }
      }
    }
  }
  //对标上市企业
  .benchmarking{
    margin-left: 0;
  }

  .jiaosou{
    background-image: url("../../assets/img/home/1746602841_rvJN.jpg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding: 40px 0;
    >div{
      width: 70%;
      margin: 0 auto;
    }
    .line2{
      display: flex;
      justify-content: space-between;
      align-items: center;
      img{
        width: 50%;
      }
      .desc{
        flex: 1;
        text-align: left;
        margin-left: 40px;
        >div{
          font-size: 1.1rem;
          line-height: 2rem;
        }
      }
    }
    @media screen and (max-width: 768px) {
      background-image: url("../../assets/img/home/1746602841_rvJN.jpg");
      background-repeat: no-repeat;
      background-size: auto 100%;
      padding: 20px 0;
      height: auto;
      >div{
        width: 90%;
        margin: 0 auto;
      }
      .line2{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        img{
          width: 90%;
        }
        .desc{
          flex: 1;
          text-align: left;
          >div{
            font-size: 1rem;
            line-height: 2rem;
          }
        }
      }
    }
  }
  .jyfw{
    width: 70%;
    margin: 30px auto;
    background-color: #fff;
    img{
      width: 80%;
      margin-left: 10%;
    }
    @media screen and (max-width: 768px) {
      width: 90%;
      margin: 30px auto;
      background-color: #fff;
      img{
        width: 100%;
        margin-left: 0;
      }
    }
  }
  .dbssqy{
    width: 70%;
    margin: 30px auto;
    background-color: #fff;
    .imgs{
      display: flex;
      justify-content: space-around;
      align-items: center;
      img{
        flex: 1;
        padding: 0 10px;
        display: block;
        box-sizing: border-box;
      }
    }
    @media screen and (max-width: 768px) {
      width: 90%;
      margin: 30px auto;
      background-color: #fff;
      .imgs{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        img{
          width: 100%;
          display: block;
          box-sizing: border-box;
          margin-bottom: 20px;
        }
      }
    }
  }
}

.presented{
  display: flex;
  flex-direction: column;
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
    align-items: center;
    padding: 1rem 0;
  }
  .presented-sub{
    font-size: 1rem;
    color: #fccc0c;
    font-weight: normal;
    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
}
</style>
